import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Paper, TextField, Typography } from '@mui/material';

import { BackButton, PageTitle } from '../../../../components/common';
import ButtonContainer from '../../../../components/ButtonContainer';
import { invalidFillingCountRegex } from '../../../../shared/regex';

import {
  DENTOLO_FILLING_COUNT,
  useNewDentoloFormDataValue,
} from '../../claimFormData/newClaimFormData';
import { useFillingCountBackButtonLink, useFillingCountNextButtonLink } from './fillingCountHooks';

const maxValue = 100;

export default function FillingCount() {
  const intl = useIntl();

  const { claimId } = useParams();

  const [fillingCount, setFillingCount] = useNewDentoloFormDataValue(DENTOLO_FILLING_COUNT);

  const backButtonLink = useFillingCountBackButtonLink(claimId);
  const nextButtonLink = useFillingCountNextButtonLink(claimId);

  const history = useHistory();

  // validation: `min: 1` `max: 100`
  const [isValidCount, setIsValidCount] = useState(true);

  const handleFillingCountKeyDown = (ev) => {
    if (!ev) return;

    const regex = new RegExp(invalidFillingCountRegex);

    if (regex.test(ev?.key)) {
      ev.preventDefault();
    }
  };

  const handleFillingCountBlur = (ev) => {
    if (!ev) return;

    // let value = ev?.target?.value?.replace('-', '');
    const value = ev?.target?.value;

    if (parseInt(value, 10) < 1 || Number.isNaN(Number(value)) || parseInt(value, 10) > maxValue) {
      setIsValidCount(false);
      setFillingCount('');
    } else if (value) {
      setIsValidCount(true);
      setFillingCount(value);
    }
  };

  const handleFillingCountChange = (ev) => {
    if (!ev) return;

    setIsValidCount(true);
    setFillingCount(ev?.target?.value);
  };

  const isFormValid = !!fillingCount && isValidCount;

  return (
    <>
      <BackButton to={backButtonLink}>
        <Typography variant="h3">
          <FormattedMessage id="common.button.back" />
        </Typography>
      </BackButton>

      <PageTitle>
        <Typography variant="h1">
          <FormattedMessage id="dentolo.new_claim.filling_count.page.title" />
        </Typography>
      </PageTitle>

      <Paper>
        <TextField
          fullWidth
          id="filling_count"
          name="filling_count"
          placeholder={intl.formatMessage({
            id: 'dentolo.new_claim.filling_count.form.label.filling_count',
          })}
          label={
            <Typography variant="h3" component="span">
              <FormattedMessage id="dentolo.new_claim.filling_count.form.label.filling_count" />
            </Typography>
          }
          required
          value={fillingCount}
          onChange={handleFillingCountChange}
          onBlur={handleFillingCountBlur}
          onKeyDown={handleFillingCountKeyDown}
          error={!isValidCount}
          helperText={
            !isValidCount && (
              <Typography variant="p" color="error">
                <FormattedMessage id="dentolo.new_claim.filling_count.form.error.invalid_filling_count" />
              </Typography>
            )
          }
          slotProps={{
            htmlInput: {
              'data-testid': 'new-claim-filling-count-input',
            },
          }}
        />
      </Paper>

      <ButtonContainer>
        <Button
          onClick={() => history.push(nextButtonLink)}
          disabled={!isFormValid}
          data-testid="next-button"
        >
          <Typography variant="buttons">
            <FormattedMessage id="common.button.next" />
          </Typography>
        </Button>
      </ButtonContainer>
    </>
  );
}
